<app-filter-input
    [property]="filter"
    [preventTab]="true"
    (filterRef)="saveFilterRef($event)"
></app-filter-input>
